import { createSlice } from '@reduxjs/toolkit'
import {
  InitialModerationStateType,
  SetQueryParams,
  GetListedItems,
  SetCategories,
  FetchNonprofits,
  FetchNonprofitsSuccess,
  ChangeVisibleHandlerType,
  ErrorActionType,
} from './contracts'
import { defaultItemsCount } from '../../settings/home-page-settings'

const initialState: InitialModerationStateType = {
  isModerator: false,
  itemsList: [],
  loading: true,
  totalPages: 0,
  needApply: true,
  firstRender: true,
  isFilterCollapsed: true,
  query: {
    pageIndex: 1,
    pageSize: defaultItemsCount,
    showSold: false,
    moderationState: ''
  },
  error: null,
  moderationState: ''
}

const moderationPageListedItemsSlice = createSlice({
  name: 'moderationPageListedItems',
  initialState: { ...initialState },
  reducers: {
    setShowItems(state, action) {},
    setInitialState(state) {
      state.isModerator = false
      state.itemsList = []
      ;(state.firstRender = true),
        (state.query = {
          pageIndex: 1,
          pageSize: defaultItemsCount,
          showSold: false,
          moderationState: ''
        })
    },
    fetchNonprofits(state, action: FetchNonprofits) {},
    setQueryParams(state, action: SetQueryParams) {
      const {
        pageIndex,
        pageSize,
        isApply,
        isStartPagingInBegin,
        showSold,
        moderationState
      } = action.payload
      if (pageIndex) state.query.pageIndex = pageIndex
      if (pageSize) state.query.pageSize = pageSize
      if (isApply) state.needApply = true

      if (moderationState) {
        state.query.moderationState = moderationState
      } else if (moderationState === null || moderationState === '') {
        state.query.moderationState = ''
      }

      if (isStartPagingInBegin) state.query.pageIndex = 1
    },
    getListedItems(state, action: GetListedItems) {
      state.loading = true
      state.needApply = false
    },
    getListedItemsSuccess(state, action) {
      state.itemsList = [...(action.payload.data ? action.payload.data.values : [])]
      state.totalPages = action.payload.data.totalPages
      state.firstRender = false
      state.loading = false
    },
    getListedItemsFailed(state) {
      state.loading = false
      state.firstRender = false
      state.totalPages = 0
      state.itemsList = []
    },
    setError(state, action: ErrorActionType) {
      state.error = action.payload
    },
    changeFilterCollapsedAction(state, action: ChangeVisibleHandlerType) {
      state.isFilterCollapsed = action.payload
    },
  },
})

export const moderationListedItems = moderationPageListedItemsSlice.reducer
export const {
  setInitialState,
  setQueryParams,
  getListedItems,
  getListedItemsSuccess,
  getListedItemsFailed,
  fetchNonprofits,
  changeFilterCollapsedAction,
  setError,
} = moderationPageListedItemsSlice.actions
